import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import CategoryDropdown from './components/CategoryDropdown';
import FeaturedCategories from './components/FeaturedCategories';
import ArticleCardsSection from './components/ArticleCardsSection';
import AboutSection from './components/AboutSection';
import TestimonialSection from './components/TestimonialSection';
import CTASection from './components/CTASection';
import JsonLd from '@/components/base/JsonLd';
import { siteJsonLd } from '@/mocks/seo-data';

export default function Home() {
  return (
    <main>
      <JsonLd data={siteJsonLd} />
      <Navbar />
      <HeroSection />
      <CategoryDropdown />
      <FeaturedCategories />
      <ArticleCardsSection />
      <AboutSection />
      <TestimonialSection />
      <CTASection />
      <Footer />
    </main>
  );
}